import firebase from 'firebase/app';

export default function getFieldPath() {
    return firebase.firestore.FieldPath;
}
